import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import { setCategoryPageNrAction, setCategoryRefetchFlagAction, setCategorySortByAction } from 'store/category/slice';
import { sortAlgToNumber } from 'utils/family/sortAlgMapping';
import getDefaultSortOrderByCategoryId from 'utils/getDefaultSortOrderByCategoryId';
import parseCategoryPageParamsServer from 'utils/routes/parseCategoryPageParamsServer';
import getCategoryId from '../selector/getCategoryId';
import setCategoryFiltersSelectionPHPWayOperation from './setCategoryFiltersSelectionPHPWayOperation';

const setParamsFromQueryStringServerOperation =
  (queryString: URLSearchParams | any) =>
  (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const { pageNr, sortBy } = parseCategoryPageParamsServer(queryString);
    if (sortBy) {
      dispatch(setCategorySortByAction(sortAlgToNumber(sortBy)));
    } else {
      dispatch(setCategorySortByAction(getDefaultSortOrderByCategoryId(getCategoryId(getState()) || 1)));
    }

    dispatch(setCategoryPageNrAction(Number(pageNr)));
    dispatch(setCategoryRefetchFlagAction(true));
    dispatch(setCategoryFiltersSelectionPHPWayOperation(queryString));
  };

export default setParamsFromQueryStringServerOperation;
